export default __webpack_public_path__ + "ab3eff25fbd53db19f8c47cf0851942d.mp3";